module.exports = __webpack_public_path__ + "img/客户预开户操作手册5188.bc0abf6c.png";